import { Injectable } from "@angular/core"
import { JwtHelperService } from "@auth0/angular-jwt"
import { Router } from '@angular/router'
// import {Observable} from "rxjs"

@Injectable()
export class AuthService {
  constructor(
    public jwtHelper: JwtHelperService,
    private router: Router
  ) { }
  public isAuthenticated(): boolean {
    const token = localStorage.getItem("token") || ''
    try {
      if (this.jwtHelper.isTokenExpired(token)) {
        localStorage.clear()
        return false
      }
      else
        return true
    } catch (e) {
      localStorage.clear()
      return false
    }
  }

  public setLogin(token: string): void {
    localStorage.setItem("token", token)
  }
  public getLogin(): string {
    return localStorage.getItem("token") || ''
  }
  public setRemoveToken(): void {
    return localStorage.removeItem("token")
  }

  public logOut(): void {
    localStorage.clear()
    this.router.navigate(["public/login"], { replaceUrl: true })
  }
}
